/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Form_OrInputs */

const en_support_form_or = /** @type {(inputs: Support_Form_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

const id_support_form_or = /** @type {(inputs: Support_Form_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atau`)
};

/**
* | output |
* | --- |
* | "or" |
*
* @param {Support_Form_OrInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_form_or = /** @type {((inputs?: Support_Form_OrInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Form_OrInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_form_or(inputs)
	return en_support_form_or(inputs)
});